
import { createClient } from '@supabase/supabase-js';

// Determinar o ambiente correto
const isDevelopment = window.location.hostname === 'localhost' || 
                       window.location.hostname === '127.0.0.1' ||
                       window.location.hostname.includes('lovable.app');

// URLs do Supabase
const supabaseUrl = 'https://quzbgarbzdazlpkiozqk.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InF1emJnYXJiemRhemxwa2lvenFrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzYzNjM3MzYsImV4cCI6MjA1MTkzOTczNn0.QbF0yjvlwBiRLkUCuTrwnW73vMTrjWBa2p0TdYI8F0A';

// URLs da aplicação
const siteUrl = isDevelopment ? 
                'http://localhost:3000' : 
                'https://agenteia.anoteja.com.br';

console.log('Iniciando cliente Supabase com:', { 
  ambiente: isDevelopment ? 'desenvolvimento' : 'produção',
  url: supabaseUrl,
  siteUrl: siteUrl 
});

// Create a single instance of the Supabase client
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    detectSessionInUrl: true,
    autoRefreshToken: true,
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
    flowType: 'pkce',
    debug: isDevelopment,
  },
});

// Create a single instance for admin operations using anon key as fallback
export const supabaseAdmin = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
    flowType: 'pkce',
    debug: isDevelopment,
  },
});
